<template>
  <div class="schedule-timeline">
    <div class="hour"
         :style="hourStyles"
         v-for="(hour, index) in hours"
         :key="index">{{ hour }}</div>
  </div>
</template>

<script>
  import { generateTimeSeries } from '@/services/intl'

  export default {
    props: {
      minBlockTime: {
        required: true,
        type: Number
      },
      minBlockHeight: {
        required: true,
        type: Number
      }
    },

    computed: {
      hours() {
        return generateTimeSeries()
      },

      hourStyles() {
        let hourHeight = (60 / this.minBlockTime) * this.minBlockHeight

        return {
          height: hourHeight + 'px'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .schedule-timeline {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex: 0 0 40px;
    margin: 40px 10px 0 0;
    overflow: hidden;

    color: #b9b9b9;
    font-size: 12px;
  }
</style>
